module.exports = __webpack_public_path__ + "img/sidebar.e45a0e7a.svg";